import React from 'react';
import { AppProvider } from './components/Context';
import Header from './components/Header';
import Intro from './components/Intro';
import Business from './components/Business';
import Footer from './components/Footer';
import './style/index.scss';

class App extends React.Component {
  render() {
    return (
      <AppProvider>
        <div className="app">
          <Header />
          <Intro />
          <Business />
          <Footer />
        </div>
      </AppProvider>
    );
  }
}

export default App;
